<p>
  data-survey-field-selector works!
</p>
